import { useNavigate, useLocation } from "react-router-dom";
import { TrendingUp, Crown } from "lucide-react";
import { cn } from "@/lib/utils";

interface PersonaSwitcherProps {
  className?: string;
  onNavigate?: () => void;
}

export const PersonaSwitcher = ({ className, onNavigate }: PersonaSwitcherProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isFounderActive = location.pathname.startsWith("/for-founders") ||
    location.pathname.startsWith("/ceo/sample-report");
  const isInvestorActive = !isFounderActive;

  const handleSwitch = (persona: "investor" | "ceo") => {
    localStorage.setItem(
      "provenance-persona",
      JSON.stringify({
        persona,
        timestamp: Date.now(),
        rememberChoice: true,
      })
    );

    if (persona === "ceo") {
      navigate("/for-founders");
    } else {
      navigate("/");
    }

    onNavigate?.();
  };

  return (
    <div className={cn("inline-flex items-center rounded-full border border-border/60 bg-muted/40 p-0.5", className)}>
      <button
        onClick={() => handleSwitch("investor")}
        className={cn(
          "flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-all duration-200",
          isInvestorActive
            ? "bg-primary/15 text-primary shadow-sm border border-primary/30"
            : "text-muted-foreground hover:text-foreground"
        )}
      >
        <TrendingUp className="h-3 w-3" />
        Investors
      </button>
      <button
        onClick={() => handleSwitch("ceo")}
        className={cn(
          "flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium transition-all duration-200",
          isFounderActive
            ? "bg-amber-500/15 text-amber-600 dark:text-amber-400 shadow-sm border border-amber-500/30"
            : "text-muted-foreground hover:text-foreground"
        )}
      >
        <Crown className="h-3 w-3" />
        Founders
      </button>
    </div>
  );
};
